export default __webpack_public_path__ + "static/media/320x320.0e701d37.jpg";